// extracted by mini-css-extract-plugin
module.exports = {"container":"textFilter_container__2C0F4","text":"textFilter_text__1wHiE","filter":"textFilter_filter__2oGno"};